function formatCurrencyString(value, currencyCode = 'USD') {
    return new Intl.NumberFormat(window.navigator.language, { style: 'currency', currency: currencyCode }).format(value);
};

export default formatCurrencyString;